module.exports = "/_next/static/files/f6109e2a86e467b26fc4beb33f7750e1.jpg";